<script setup lang="ts">
import * as Sentry from '@sentry/vue';

interface ErrorPayload {
  statusCode?: number;
  statusMessage?: string;
  message?: string;
  url?: string;
  stack?: string;
}

const props = defineProps<{
  error?: ErrorPayload;
}>();

try {
  if (new URL(location.href).hostname !== new URL(document.referrer).hostname) {
    if (document.referrer) {
      sessionStorage.setItem('c_documentReferrer', document.referrer);
      localStorage.setItem('c_documentReferrerLocal', document.referrer);
    }
  }
} catch (ex) {}

onMounted(() => {
  try {
    const err = props.error || {};
    const statusCode = err.statusCode ?? 'unknown';
    const message = err.message || err.statusMessage || 'no message';

    Sentry.captureMessage(`error.vue rendered: ${statusCode} ${message}`, {
      level: statusCode === 404 ? 'warning' : 'error',
      tags: {
        source: 'error.vue',
        status_code: String(statusCode),
      },
      extra: {
        currentUrl: location.href,
        currentPath: location.pathname,
        currentSearch: location.search,
        currentHash: location.hash,
        referrer: document.referrer || '(empty)',
        errorUrl: err.url,
        errorStatusMessage: err.statusMessage,
        errorMessage: err.message,
        errorStack: err.stack,
        userAgent: navigator.userAgent,
        isStandalonePwa:
          window.matchMedia?.('(display-mode: standalone)')?.matches ?? false,
        viewport: `${window.innerWidth}x${window.innerHeight}`,
        online: navigator.onLine,
      },
    });
  } catch {}
});
</script>

<template>
  <NuxtLayout>
    <BaseErrorMessage
      image-type="error"
      :message="$t('error.page_not_found.message')"
      :subtitle="$t('error.page_not_found.subtitle')"
      :title="$t('error.ops')"
    >
      <button @click="$router.push(localeLink('/'))">
        {{ $t('error.page_not_found.button') }}
      </button>
    </BaseErrorMessage>
  </NuxtLayout>
</template>
